import { Component, Inject, OnInit } from "@angular/core";
import { FruitsServiceService } from "./fruits-service.service";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as constants from "../../constant";
import * as HindiText from "../../mp-popup-message";
import { environment as ENV } from "../../../environments/environment";
import { OpenDialogYesOrNo } from "../dialog-yes-or-no/dialog-yes-or-no.component";
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ApplicantService } from "../applicant.service";
import * as CryptoJS from "crypto-js";
import { BaseApi } from "../base-api.service";
import { Router } from "@angular/router";
import * as lodash from "lodash"
import { map } from "rxjs/operators";

@Component({
  selector: "wl-fruits-land-record",
  templateUrl: "./fruits-land-record.component.html",
  styles: [],
  providers: [FruitsServiceService],
})
export class FruitsLandRecordComponent implements OnInit {
  LandRecordArrayData: any;
  selectedLandDetails: any;
  isFetchButtonDisabled: boolean = true;
  fruitsAPIResponse: any;
  showLandRecordForm: boolean;
  SurveyNoWithVillage: any = [];
  isNTB: boolean;
  ownershipForm: UntypedFormGroup;
  pdfArray: any;
  mappingData: any;
  noOfDocuments: any;
  readOnlyArray: any = [];
  docPath: any;
  index: any = 0;
  aadhaarNumber: any;
  showFetchButton: boolean;
  name: any;
  acreOrHectare: string;
  stateCode: string;
  feedbackflag: boolean;
  disableSubmitLandRecords: boolean;
  isLandBreFailure: boolean = false;
  repeatGetCreditScoreAPICount = 1;
  pointerStyle: object;
  isSubmitting: boolean = false;
  showInput: boolean = false;
  originalArray: any[] = [];
  existingDataArray: any[] = [];
  matchedArrays: any[];
  isMatch: boolean;
  hideSubmitButton: boolean;
  showDelete: boolean;
  creditCheckRequired: any;
  loading: boolean;
  disableBcoz5landsAlready: boolean;

  constructor(
    private fruitsService: FruitsServiceService,
    private applicant: ApplicantService,
    private dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private api: BaseApi,
    private router: Router,
    private snackbar: MatSnackBar
  ) {
    this.ownershipForm = this.fb.group({
      bhoomi_details: this.fb.array([]),
    });

    if (this.applicant.shouldIbeClicked()) {
      this.pointerStyle = { 'pointer-events': 'auto' }
    } else {
      this.pointerStyle = { 'pointer-events': 'none' }
    }
  }

  bhoomi_details(): UntypedFormArray {
    return this.ownershipForm.get("bhoomi_details") as UntypedFormArray;
  }


  newBhoomiDetail(): UntypedFormGroup {
    return this.fb.group({
      name_as_per_bhumi: "",
      land_area: "",
      land_ownership: "",
      charge_details: "",
      // land_value: ''
    });
  }

  addBhoomiDetail() {
    this.bhoomi_details().push(this.newBhoomiDetail());
  }

  ngOnInit() {
    let stateValue = sessionStorage.getItem('wEnlw3OeU3')

    if (stateValue == "xmpHUKBVNVSFG61XnJAzKOQ32EWjSdE1") {
      this.acreOrHectare = "Hectare"
      this.stateCode = "MP"
    } else if (stateValue == "KDw2nS6vb5cJ286KJ3JwtGKGnnnLO93Y") {
      this.acreOrHectare = "Acre"
      this.stateCode = "KA"
    }

    this.fruitsService.getApplicantData({appId: sessionStorage.getItem('wl-applicant-id')}).subscribe((resp) => {
      console.log(resp);
      if (resp && resp.success) {
        if (resp && resp.result && resp.result.docs && resp.result.docs.assets && resp.result.docs.assets.bhoomi && resp.result.docs.assets.bhoomi.files) {
          this.originalArray = resp.result.docs.assets.bhoomi.files;
          this.extractAndPushToArray();
        }


        if (
          resp &&
          resp.result &&
          resp.result.aadhar_details &&
          resp.result.aadhar_details.aadharNo
        ) {
          this.aadhaarNumber = resp.result.aadhar_details.aadharNo;
          this.name = resp.result.profile.name;
          this.showFetchButton = true;
        } else {
          this.showFetchButton = false;
          const dialogRef = this.showDialog(
            "auto",
            "auto",
            "",
            "Land records cannot be fetched as Aadhaar number not found.",
            "OK"
          );
        }
      }
    });

    this.applicant.getProfile().subscribe((resp) => {
      console.log(resp, "in profile on load");
      if (resp && resp.name) {
        sessionStorage.setItem("rfvtgb", this.encrypt(resp.name));
      }
    });

    this.applicant.getLandDetails().subscribe(resp => {
      console.log('submit', resp);
      if (resp && resp.landSubmitStatus && resp.landSubmitStatus == true) {
        this.hideSubmitButton = true;
        this.showDelete = false;
      } else {
        this.hideSubmitButton = false;
      }
    })

    this.fruitsService.get().subscribe((resp) => {
      console.log("resultsssssss", resp);
      // resp = bhhomidata;
      if (resp && resp.files) {
        this.docPath = resp.files;
        console.warn(this.docPath, "Docpaths");
        this.pdfArray = resp.files;
        let mappingData = resp.files.reverse();
        this.mappingData = mappingData;
        this.noOfDocuments = mappingData.length;
        this.index = this.noOfDocuments;
        //Priority
        // one - LR
        // two - Credit report
        // three - SMS
        // four - Satsure

        if (this.noOfDocuments > 0) {
          this.applicant.getOverAllStatus().subscribe(resp => {
            console.log('getOverAllStatus---->', resp)
            let overAllResp = resp;
            if (resp && resp.message == 'success') {
              if (resp && resp.data && resp.data.landDetails && resp.data.landDetails == true) {
                if (resp && resp.data && resp.data.cicReport && resp.data.cicReport == true) {
                  if (resp && resp.data && resp.data.npaStatus == false) {
                    if (resp && resp.data && resp.data.isSmsSent == false && resp.data.consent_feedback_status.toLowerCase() == "pending") {
                      this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                        console.log('sms--->', resp);
                        if (resp && resp.success) {

                        }
                      })
                    } else if (resp && resp.data && resp.data.isSmsSent == true && resp.data.consent_feedback_status.toLowerCase() == "yes" && resp.data.satSureData == false) {
                      let data = {
                        appId: sessionStorage.getItem('wl-applicant-id'),
                      }
                      this.applicant.callSatsure(data).subscribe(resp => {
                        console.log('callSatsureApi--->', resp);
                      })
                    } else {
                      // do nothing
                      console.log('is sms already sent or consent form is submited')
                    }
                  } else {

                  }

                } else {
                  console.log('credit report not present')
                  this.applicant.getCreditData(this.stateCode, this.repeatGetCreditScoreAPICount).subscribe(resp => {
                    console.log('getCreditData--->API', resp);
                    if (
                      resp &&
                      resp.success == true &&
                      (resp.message == "Report Generated Successfully" ||
                        resp.message == "Credit Report fetched successfully")
                    ) {
                      if (resp.npaStatusFlag && resp.npaStatusFlag == true) {
                        this.snackbar.open('NPA status found', 'OK', { duration: 3000 })
                      } else {
                        // if (resp && resp.success) {
                        if (resp && resp.npaStatusFlag == false) {
                          if (overAllResp && overAllResp.data && overAllResp.data.isSmsSent == false && overAllResp.data.consent_feedback_status.toLowerCase() == "pending") {
                            this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                              console.log(resp)
                              if (resp && resp.success) {
                                console.log('sms sent')
                              } else {
                                console.log('sms not sent')
                              }
                            })
                          } else if (overAllResp && overAllResp.data && overAllResp.data.isSmsSent == true && overAllResp.data.consent_feedback_status.toLowerCase() == "yes" && overAllResp.data.satSureData == false) {
                            let data = {
                              appId: sessionStorage.getItem('wl-applicant-id'),
                            }
                            this.applicant.callSatsure(data).subscribe(resp => {
                              console.log('callSatsureApi--->', resp);
                            })
                          } else {
                            // do nothing
                            console.log('is sms already sent or consent form is submited')
                          }
                        } else {
                          // do nothing
                          console.log('npa status is true')
                        }
                        // } else {
                        //   console.log('no credit API response --- unsuccess')
                        //   // do nothing
                        // }
                      }

                    } else {
                      this.applicant.getCreditData(this.stateCode, this.repeatGetCreditScoreAPICount).subscribe(resp => {
                        console.log('getCreditData--->API', resp);
                        if (
                          resp &&
                          resp.success == true &&
                          (resp.message == "Report Generated Successfully" ||
                            resp.message == "Credit Report fetched successfully")
                        ) {
                          if (resp.npaStatusFlag && resp.npaStatusFlag == true) {
                            this.snackbar.open('NPA status found', 'OK', { duration: 3000 })
                          } else {

                            if (resp && resp.npaStatusFlag == false) {
                              if (overAllResp && overAllResp.data && overAllResp.data.isSmsSent == false && overAllResp.data.consent_feedback_status.toLowerCase() == "pending") {
                                this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                                  console.log(resp)
                                  if (resp && resp.success) {
                                    console.log('sms sent')
                                  } else {
                                    console.log('sms not sent')
                                  }
                                })
                              } else if (overAllResp && overAllResp.data && overAllResp.data.isSmsSent == true && overAllResp.data.consent_feedback_status.toLowerCase() == "yes" && overAllResp.data.satSureData == false) {
                                let data = {
                                  appId: sessionStorage.getItem('wl-applicant-id'),
                                }
                                this.applicant.callSatsure(data).subscribe(resp => {
                                  console.log('callSatsureApi--->', resp);
                                })
                              } else {
                                // do nothing
                                console.log('is sms already sent or consent form is submited')
                              }
                            } else {
                              // do nothing
                              console.log('npa status is true')
                            }
                          }
                        }
                      })
                    }
                  })
                }
              } else {
                console.log('landetails === false')
                this.disableSubmitLandRecords = false
              }

              /**old-------- */
              if (resp && resp.data && resp.data.consent_feedback_status) {
                if (resp.data.consent_feedback_status.toLowerCase() == "yes") {
                  this.feedbackflag = true
                  this.isSubmitting = true;
                } else {
                  this.feedbackflag = false
                  this.isSubmitting = false;
                }
              }
              if (resp && resp.data && resp.data.satSureData == true && resp.data.isSmsSent == true) {
                this.disableSubmitLandRecords = true
              } else if (resp && resp.data && resp.data.satSureData == false) {
                let data = {
                  appId: sessionStorage.getItem('wl-applicant-id'),
                }
                // this.applicant.callSatsure(data).subscribe(resp => {
                //   console.log(resp)
                // })
              } else if (resp && resp.data && resp.data.satSureData == true && resp.data.isSmsSent == false) {
                this.disableSubmitLandRecords = false
                this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                  console.log(resp)
                  if (resp && resp.success) {
                    this.disableSubmitLandRecords = true
                  }

                })
              } else if (resp && resp.data && resp.data.satSureData == false && resp.data.isSmsSent == true && this.feedbackflag) {
                // this.disableSubmitLandRecords = false
                let data = {
                  appId: sessionStorage.getItem('wl-applicant-id'),
                }
                this.applicant.callSatsure(data).subscribe(resp => {
                  console.log(resp)
                })
              } else if (resp && resp.data && resp.data.satSureData == false && resp.data.isSmsSent == true && !this.feedbackflag) {

              }
              /**old-------- */
            } else {
              console.log('getOverAllStatus unsuccess')
            }
          })
        } else {
          console.log('document lenght is zero')
        }

        console.log(mappingData, "MAPPING DATA");
        let name_as_per_bhumi = this.decrypt(sessionStorage.getItem("rfvtgb"));
        console.log(name_as_per_bhumi, "name from sessionStorage");
        for (let i = 0; i < mappingData.length; i++) {
          if (mappingData[i].bhoomi_details) {
            // debugger
            let data = mappingData[i].bhoomi_details.Landdata;
            let acres = data[0].ExtAcre ? data[0].ExtAcre : 0;
            let guntas = data[0].ExtGunta ? data[0].ExtGunta : 0;
            let totalAcres = (acres + guntas / 40).toFixed(2);
            (this.ownershipForm.controls.bhoomi_details as UntypedFormArray).push(
              this.fb.group({
                name_as_per_bhumi: [name_as_per_bhumi ? name_as_per_bhumi : ""],
                land_area: [totalAcres ? totalAcres : ""],
                land_ownership: [
                  data[0]["OwnerName"]
                    ? data[0]["OwnerName"]
                    : "",
                ],
                charge_details: [
                  mappingData[i].bhoomi_details.charge_details
                    ? mappingData[i].bhoomi_details.charge_details
                    : "",
                ],
              })
            );
            if (
              mappingData[i].bhoomi_details.land_area ||
              mappingData[i].bhoomi_details.land_ownership ||
              mappingData[i].bhoomi_details.charge_details
            ) {
              console.log(mappingData[i]);
              this.readOnlyArray.push(true);
              if (i < mappingData.length - 1) {
                console.log(this.readOnlyArray);
              }
            }
          } else {
            (this.ownershipForm.controls.bhoomi_details as UntypedFormArray).push(
              this.fb.group({
                name_as_per_bhumi: [name_as_per_bhumi ? name_as_per_bhumi : ""],
                land_area: [""],
                land_ownership: [""],
                charge_details: [""],
                // land_value: [""]
              })
            );
            this.readOnlyArray.push(false);
            if (i < mappingData.length - 1) {
              console.log(this.readOnlyArray);
            }
          }
        }

        console.log((this.ownershipForm.controls.bhoomi_details as UntypedFormArray).length)
        if((this.ownershipForm.controls.bhoomi_details as UntypedFormArray).length == 5){
          this.disableBcoz5landsAlready = true;
          this.snackbar.open("Maximum 5 land records only allowed","OK",{duration:5000})
          // return
        }
      } else {
        this.docPath = []
      }
    });
  }
  secretKey = "YourSecretKeyForEncryption&Descryption";
  encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.secretKey.trim()).toString();
  }

  decrypt(textToDecrypt: string) {
    return CryptoJS.AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(
      CryptoJS.enc.Utf8
    );
  }

  extractAndPushToArray() {
    console.log(this.originalArray)
    this.originalArray.forEach(item => {
      this.existingDataArray.push(item.input.district, item.input.taluk, item.input.hobli, item.input.village, item.input.Surveyno, item.input.Hissano);
      console.log('newway', this.existingDataArray)
    });
  }

  splitArray(array, chunkSize) {
    const result = [];

    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }

    return result;
  }

  checkArrayMatch(arr1: any[], arr2: any[]): boolean {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }

  getLandDataFromFruitsApi(aadharNo) {
    this.loading = true;

    let data = {
      id: this.aadhaarNumber,
      name2: this.name,
      appId: sessionStorage.getItem('wl-applicant-id')
    };
    this.fruitsService
      .getLandRecordDataUsingFruitsAPI(data)
      .subscribe((fruitsApiResult) => {
        this.loading = false;
        // fruitsApiResult = fruitsNaveenData;
        // fruitsApiResult = fruitsShashiData;
        console.log(fruitsApiResult)
        if (fruitsApiResult && fruitsApiResult.success) {
          this.isSubmitting = true;
          this.fruitsAPIResponse = fruitsApiResult["result"]["data"];
          let landResponse = this.fruitsAPIResponse["Landdata"];
          // debugger

          if (landResponse && landResponse.length) {
            let landDataNotSelected: any = []
            if (this.docPath && this.docPath.length > 0) {
              let newDocPath = []
              this.docPath.map(item => {
                newDocPath.push(item.bhoomi_details)
              })
              // let landDataNotSelected = this.getIntersectFirstArray(newDocPath, landResponse);
              // console.log(this.docPath, landResponse)
              console.log(JSON.stringify(newDocPath))
              landDataNotSelected = this.getUniqueLands(landResponse, newDocPath)
              console.log('landDataNotSelected---->', landDataNotSelected)

              landDataNotSelected = this.getIntersectFirstArray(newDocPath, landResponse);

              landDataNotSelected = this.getLandArrayLodash(landResponse, newDocPath)
              // console.log(this.isArrayEqual([{a:1, b:2}, {c:3, d:4}], [{b:2, a:1}, {d:4, c:3}]))


              //console.log(JSON.stringify(landResponse))
              //console.log(this.isArrayEqual(newDocPath, landResponse))
            } else {
              landDataNotSelected = landResponse
            }

            console.log(landDataNotSelected)
            console.log(data);
            if (landDataNotSelected.length > 0) {
              this.showLandRecordForm = true;
              Promise.all([this.filterLandData(landResponse)])
                .then((filteredData: any) => {
                  console.log("---------", filteredData[0]);
                  this.LandRecordArrayData = filteredData[0];
                  let index = 0;
                  let combiledData = filteredData[0].map((obj) => {
                    let objct = {};

                    objct["name"] = obj.VillageName;
                    objct["id"] = obj.LandCode;
                    objct["engname"] = obj.Surveyno;
                    objct["combinedName"] =
                      obj.DistrictName +
                      "-" +
                      obj.TalukName +
                      "-" +
                      obj.HobliName +
                      "-" +
                      obj.VillageName +
                      "-" +
                      obj.Surveyno +
                      "/" +
                      obj.Surnoc +
                      "/" +
                      obj.Hissano +
                      "-" +
                      obj.ExtAcre;
                    objct["index"] = index;
                    index++;

                    return objct;
                  });
                  this.SurveyNoWithVillage = combiledData;
                })
                .catch((err) => {
                  console.log("err--->", err);
                });
            } else {
              if (
                this.fruitsAPIResponse.StatusText ==
                constants.FRUITS_API_STATUS_TEXT.FARMER_ID_NOT_FOUND
              ) {
                const dialogRef = this.showDialog(
                  "auto",
                  "auto",
                  HindiText.FARMER_ID_NOT_FOUND.kannada,
                  HindiText.FARMER_ID_NOT_FOUND.english,
                  "OK"
                );
              } else if (
                this.fruitsAPIResponse.StatusText ==
                constants.FRUITS_API_STATUS_TEXT.AADHAR_NOT_VALIDATED
              ) {
                const dialogRef = this.showDialog(
                  "auto",
                  "auto",
                  HindiText.LAND_DATA_AADHAR_NOT_VALIDATED.kannada,
                  HindiText.LAND_DATA_AADHAR_NOT_VALIDATED.english,
                  "OK"
                );
              } else {
                const dialogRef = this.showDialog(
                  "auto",
                  "auto",
                  HindiText.FAILED_TO_FETCH_LAND_DATA.kannada,
                  HindiText.FAILED_TO_FETCH_LAND_DATA.english,
                  "OK"
                );
              }
            }
          } else {
            const dialogRef = this.showDialog(
              "auto",
              "auto",
              "",
              "No land data found",
              "OK"
            );
          }

        } else {
          this.isSubmitting = false;
          // show failed to fetch land details
          if (fruitsApiResult && fruitsApiResult["message"]) {
            const dialogRef = this.showDialog(
              "auto",
              "auto",
              "",
              fruitsApiResult["message"],
              "OK"
            );
          }
        }
      },(err)=>{
        this.loading = false;
        this.snackbar.open("Failed to fetch Land records. Please try later.","OK",{duration:5000})
      });
  }

  getUniqueLands(x: any, y: any) {

    console.log('x---------->', x);
    console.log('y---------->', y);
    return x.filter(function (obj) {
      return !y.some(function (obj2) {
        return obj.LandCode == obj2.LandCode;
      });
    });
    // let count = 0;
    // let arrayNew = []
    // x.forEach(element => {
    //   let someArray = y.find((item) => item.LandCode != element.LandCode);
    //   arrayNew.push(someArray);
    //   count++;
    //   if(count == x.length) {
    //     return arrayNew;
    //   }
    // });
  }

  getLandArrayLodash(array2, array1) {
    return lodash.differenceWith(array2, array1, lodash.isEqual)
  }

  getIntersectFirstArray(arr1, arr2) {
    try {
      let temp = [];
      debugger
      for (let i = 0; i < arr1.length; i++) {
        let obj = false;
        // for(let key1 in arr1) {
        for (let j = 0; j < arr2.length; j++) {
          for (let key2 in arr2[j]) {
            if (arr1[i][key2] == arr2[j][key2]) {
              obj = true;
            }
          }
        }
        if (!obj) temp.push(arr1[i]);
        // }
      }
      return temp;
    } catch (err) {
      return arr1
    }
  }

  filterLandData(landData: any) {
    return new Promise(async (resolve, reject) => {
      let uniqueArray = await landData.reduce((unique, o) => {
        if (
          !unique.some(
            (obj) => obj.LandCode === o.LandCode && obj.Surveyno === o.Surveyno
          )
        ) {
          unique.push(o);
        }
        return unique;
      }, []);
      console.log("uniqueArray", uniqueArray);
      resolve(uniqueArray);
    });
  }

  isArrayEqual(x, y) {
    return lodash(x).xorWith(y, lodash.isEqual).isEmpty();
  };

  handleSurveyOnChange(index: any) {
    console.log(
      "xlandRecord----->",
      index,
      this.LandRecordArrayData,
      this.LandRecordArrayData[index.value.index]
    );
    // this.selectedLandDetails = this.LandRecordArrayData[index];
    this.selectedLandDetails = this.LandRecordArrayData[index.value.index];
    // this.selectedLandDetails = this.LandRecordArrayData.find(
    //   (o: any) => o.LandCode === index.id
    // );
    console.log("selectedData---->", this.selectedLandDetails);
    if (this.selectedLandDetails) {
      this.isFetchButtonDisabled = false;
    } else {
      this.isFetchButtonDisabled = true;
    }
  }

  fetchLandRecordsFruits() {
    // this.getLandDataFromFruitsApi("996565753889");
    this.getLandDataFromFruitsApi(this.aadhaarNumber);
  }

  continueWithLandRecord(index: any) {
    //this.selectedLandDetails = this.model.option;
    console.log("VillageCode--->", this.selectedLandDetails.VillageCode);
    this.fruitsAPIResponse.Landdata = [this.selectedLandDetails];
    let breData = {
      appId: sessionStorage.getItem("mpApplicantId"),
      name2: sessionStorage.getItem("appliNme4mCbs"),
      jrnytype: "ETB",
      data: this.fruitsAPIResponse,
      type: ENV.serverType,
    };
    if (this.isNTB) {
      breData.jrnytype = "NTB";
    }
    this.isFetchButtonDisabled = true;
    this.fruitsService.getBREStatusKA(breData).subscribe((resp) => {
      console.log("---------", resp.result["land_bre_status"]);
      if (
        resp &&
        resp.message == constants.MESSAGE_SUCCESS.toLowerCase() &&
        resp.result["land_bre_status"] ==
        constants.MESSAGE_SUCCESS.toLowerCase()
      ) {
        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: "auto",
          height: "auto",
          data: {
            // content1: "ಭೂಮಿಯ ವಿವರಗಳನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಪರಿಶೀಲಿಸಲಾಗಿದೆ. ದಯವಿಟ್ಟು ಬೆಳೆ ವಿವರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ.",
            content2: constants.LAND_VERIFIED_SUCCESS,
            button1Text: "OK",
          },
        });
      } else {
        let dialogContent: any = {};
        this.isFetchButtonDisabled = false;
        if (resp && resp.message == constants.BRE_STATUS_DUPLICATE_ID) {
          dialogContent.con1 = HindiText.BRE_STATUS_DUPLICATE_ID.kannada;
          dialogContent.con2 = HindiText.BRE_STATUS_DUPLICATE_ID.english;
        } else {
          dialogContent.con1 = HindiText.LAND_REC_NOT_AS_PER_BANK.kannada;
          dialogContent.con2 = HindiText.LAND_REC_NOT_AS_PER_BANK.english;
        }

        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: "auto",
          height: "auto",
          data: {
            content1: dialogContent.con1,
            content2: dialogContent.con2,
            button1Text: "OK",
          },
        });

        dialogRef.afterClosed().subscribe((res) => {
          console.log(res);
          if (res == "close") {
            //window.close()
          } else {
            //this.ngOnInit()
          }
        });
      }
    });
  }

  deleteRecord(i) {
    console.log(i);
    this.fruitsService.deleteBhoomiRecord(i).subscribe((resp) => {
      console.log(resp);
      this.bhoomi_details().removeAt(i);
      this.router
        .navigateByUrl("/laas/bre-status", {
          skipLocationChange: true,
        })
        .then(() => {
          this.router.navigate(["/laas/land-records-ka"]);
        });
    });
  }

  submitBhoomiDetail(i) {
    debugger;
    console.log(i);
    // console.log(this.ownershipForm.value);
    let resultdata =
      this.ownershipForm.value.bhoomi_details[this.noOfDocuments - (i + 1)];
    console.log(resultdata, this.ownershipForm.value.bhoomi_details);
    this.sanitization(resultdata.land_ownership).subscribe((respp) => {
      console.log(respp, "respp");
      console.log("from irctc records");
      resultdata.profile_match = respp;
      // let formdata=this.bhumiverificationForm.getRawValue();
      this.fruitsService.save_bhoomi_details(i, resultdata).subscribe(
        (status) => {
          console.log("Bhumi Verification Report Data Saved", status);
          // this.snackbar.open("Land Record Details Saved Successfully", 'OK', { duration: 3000 });
          const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
            width: "auto",
            height: "auto",
            data: {
              heading: "Land Record Submitted Successfully",
              content: constants.DYUWANNA_GEN_NOTHER_REPORT,
              button1Text: "Yes",
              button2Text: "No",
            },
          });

          // for (let i = 0; i <this.mappingData.length; i++) {
          //   this.bhoomi_details().removeAt(i);
          // }
          // this.ngOnInit()
          dialogRef.afterClosed().subscribe((res) => {
            console.log(res);
            // this.ngOnInit()
            this.router
              .navigateByUrl("/laas/bre-status", {
                skipLocationChange: true,
              })
              .then(() => {
                this.router.navigate(["/laas/land-records-ka"]);
              });
            if (res == "close") {
              window.close();
            } else {
              // this.bhoomiForm.get('disId').reset();
              // this.bhoomiForm.get('talId').reset();
              // this.bhoomiForm.get('hobId').reset();
              // this.bhoomiForm.get('village').reset();
              // this.bhoomiForm.get('surveyno').reset();
              // this.bhoomiForm.get('surnoc').reset();
              // this.bhoomiForm.get('hisNo').reset();
              // this.bhoomiForm.get('rtcPeriod').reset();
              // this.bhoomiForm.get('land_area_bank').reset();
            }
          });
        },
        (err) => {
          this.snackbar.open(err, "OK", { duration: 3000 });
          console.log(err);
          throw err;
        }
      );
    });
  }

  submitBhoomiDetailFruits() {  //onclick of verify

    console.log(this.bhoomi_details.length, (this.ownershipForm.controls.bhoomi_details as UntypedFormArray).length);
    if((this.ownershipForm.controls.bhoomi_details as UntypedFormArray).length == 5){
      this.disableBcoz5landsAlready = true;
      this.snackbar.open("Maximum 5 land records only allowed","OK",{duration:5000})
      return
    }
    
    this.fruitsAPIResponse.Landdata = [this.selectedLandDetails];

    let breData = {
      appId: sessionStorage.getItem('wl-applicant-id'),
      name2: this.name,
      jrnytype: "RENEWAL",
      data: this.fruitsAPIResponse,
      type: ENV.serverType,
    };

    let getData = this.fruitsAPIResponse.Landdata[0]
    let my_array = []
    my_array.push(getData.DistrictName, getData.TalukName, getData.HobliName, getData.VillageName, getData.Surveyno, getData.Hissano);
    console.log('fetchdata', my_array);
    console.log('existingDataArray', this.existingDataArray)
    const chunkSize = 6;
    const splitArrays = this.splitArray(this.existingDataArray, chunkSize);
    console.log('splitArrays', splitArrays);

    this.matchedArrays = [];

    for (var targetArray of splitArrays) {
      this.isMatch = this.checkArrayMatch(my_array, targetArray);
      if (this.isMatch) {
        this.matchedArrays.push(targetArray);
        console.log('targetArray', targetArray);

      } else {
        console.log('not match')
      }
    }
    if (this.matchedArrays.length > 0) {
      this.snackbar.open('Entered Duplicate land record, Please enter different one', "OK", { duration: 8000 })
    }

    else {

      this.loading = true;
      this.fruitsService.getBREStatusKA(breData).subscribe((resp) => {
        this.loading = false;
        console.log("---------", resp.result["land_bre_status"]);
        if (
          resp &&
          resp.message == constants.MESSAGE_SUCCESS.toLowerCase() &&
          resp.result["land_bre_status"] ==
          constants.MESSAGE_SUCCESS.toLowerCase()
        ) {
          const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
            width: "auto",
            height: "auto",
            data: {
              heading: "Land Record Submitted Successfully",
              content: constants.DYUWANNA_GEN_NOTHER_REPORT,
              button1Text: "Yes",
              button2Text: "No",
            },
          });


          dialogRef.afterClosed().subscribe(res => {
            console.log(res);
            this.router
              .navigateByUrl("/laas/bre-status", {
                skipLocationChange: true,
              })
              .then(() => {
                this.router.navigate(["/laas/land-records-ka"]);
              }).then(() => {
                if (res == "close") {

                  let id = sessionStorage.getItem('wl-applicant-id');
                  let status = 'No'
                  let value = { status, id }
                  this.applicant.clickSubmit(value).subscribe(res => {
                    console.log('final result', res)
                    if (res.success == true) {
                      this.hideSubmitButton = true;
                      this.creditCheckRequired = res.creditCheckRequired;
                    } else {
                      this.hideSubmitButton = false;
                    }

                    this.showDelete = false;
                    this.disableSubmitLandRecords = true
                    this.applicant.getLandDetails().subscribe(resp => {
                      console.log(resp)
                      if (resp && resp.files) {
                        let mappingData = resp.files;
                        let breArray = [];
                        for (let i = 0; i < mappingData.length; i++) {
                          if (mappingData[i] && mappingData[i].land_bre_status == ("success" || "Success")) {

                          } else if (mappingData[i] && mappingData[i].land_bre_status == ("failure" || "Failure")) {
                            console.log(mappingData[i])
                            this.isLandBreFailure = true
                          }
                        }
                        // this.isLandBreFailure = false
                        if (!this.isLandBreFailure && this.creditCheckRequired) {
                          this.applicant.getCreditData(this.stateCode, this.repeatGetCreditScoreAPICount).subscribe(resp => {
                            console.log(resp)
                            if (resp && resp.success &&
                              (resp.message == "Report Generated Successfully" ||
                                resp.message == "Credit Report fetched successfully")) {
                              if (resp && resp.npaStatusFlag == false) {
                                this.fruitsService.getBreStatus().subscribe(result => {
                                  console.log(result);
                                  // result = "Failure"
                                  if (result == "Failure" || result == "failure") {
                                    this.snackbar.open(resp.bre_failure_reason ? resp.bre_failure_reason : "Failed in BRE", "OK", { duration: 5000 })
                                  } else if (result == "Success" || result == "success") {
                                    this.applicant.getOverAllStatus().subscribe(resp => {
                                      console.log(resp)
                                      if (resp && resp.message == "success") {
                                        if (resp && resp.data && resp.data.satSureData == true && resp.data.isSmsSent == true) {
                                          this.disableSubmitLandRecords = true
                                        } else if (resp && resp.data && resp.data.isSmsSent == false) {
                                          let data = {
                                            appId: sessionStorage.getItem('wl-applicant-id'),
                                          }
                                          // this.applicant.callSatsure(data).subscribe(resp => {
                                          //   console.log(resp)
                                          //   if (resp && resp.success) {
                                          this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                                            console.log(resp)
                                            if (resp && resp.success) {
                                              this.disableSubmitLandRecords = true
                                            }
                                          })
                                          //   }
                                          // })
                                        } else if (resp && resp.data && resp.data.satSureData == true && resp.data.isSmsSent == false) {
                                          // this.disableSubmitLandRecords = false
                                          this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                                            console.log(resp)
                                            if (resp && resp.success) {
                                              this.disableSubmitLandRecords = true
                                            }
                                          })
                                        } else if (resp && resp.data && resp.data.satSureData == false && resp.data.isSmsSent == true && resp.data.consent_feedback_status == "yes") {
                                          let data = {
                                            appId: sessionStorage.getItem('wl-applicant-id'),
                                          }
                                          this.applicant.callSatsure(data).subscribe(resp => {
                                            console.log(resp)
                                            if (resp && resp.success) {
                                              this.disableSubmitLandRecords = true
                                            }
                                          })
                                        } else {
                                          this.disableSubmitLandRecords = true
                                        }
                                      }
                                    })
                                  }
                                })
                              } else {
                                this.snackbar.open('NPA status found', 'OK', { duration: 3000 })
                              }
                            } else {
                              this.repeatGetCreditScoreAPICount =
                                this.repeatGetCreditScoreAPICount + 1;
                              this.applicant.getCreditData(this.stateCode, this.repeatGetCreditScoreAPICount).subscribe(resp => {
                                console.log(resp)
                                if (resp && resp.success &&
                                  (resp.message == "Report Generated Successfully" ||
                                    resp.message == "Credit Report fetched successfully")) {
                                  if (resp && resp.npaStatusFlag == false) {
                                    this.fruitsService.getBreStatus().subscribe(result => {
                                      console.log(result);
                                      // result = "Failure"
                                      if (result == "Failure" || result == "failure") {
                                        this.snackbar.open(resp.bre_failure_reason ? resp.bre_failure_reason : "Failed in BRE", "OK", { duration: 5000 })
                                      } else if (result == "Success" || result == "success") {
                                        this.applicant.getOverAllStatus().subscribe(resp => {
                                          console.log(resp)
                                          if (resp && resp.message == "success") {
                                            if (resp && resp.data && resp.data.satSureData == true && resp.data.isSmsSent == true) {
                                              this.disableSubmitLandRecords = true
                                            } else if (resp && resp.data && resp.data.isSmsSent == false) {
                                              let data = {
                                                appId: sessionStorage.getItem('wl-applicant-id'),
                                              }
                                              // this.applicant.callSatsure(data).subscribe(resp => {
                                              //   console.log(resp)
                                              //   if (resp && resp.success) {
                                              this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                                                console.log(resp)
                                                if (resp && resp.success) {
                                                  this.disableSubmitLandRecords = true
                                                }
                                              })
                                              //   }
                                              // })
                                            } else if (resp && resp.data && resp.data.satSureData == true && resp.data.isSmsSent == false) {
                                              // this.disableSubmitLandRecords = false
                                              this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                                                console.log(resp)
                                                if (resp && resp.success) {
                                                  this.disableSubmitLandRecords = true
                                                }
                                              })
                                            } else if (resp && resp.data && resp.data.satSureData == false && resp.data.isSmsSent == true && resp.data.consent_feedback_status == "yes") {
                                              let data = {
                                                appId: sessionStorage.getItem('wl-applicant-id'),
                                              }
                                              this.applicant.callSatsure(data).subscribe(resp => {
                                                console.log(resp)
                                                if (resp && resp.success) {
                                                  this.disableSubmitLandRecords = true
                                                }
                                              })
                                            } else {
                                              this.disableSubmitLandRecords = true
                                            }
                                          }
                                        })
                                      }
                                    })
                                  } else {
                                    this.snackbar.open('NPA status found', 'OK', { duration: 3000 })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.snackbar.open("Land BRE failure found.", "OK", { duration: 3000 })
                        }

                      } else {
                        this.snackbar.open("Failed to fetch Land records BRE status information.", "OK", { duration: 3000 })
                      }
                    }, () => {
                      this.snackbar.open("Failed to fetch Land records BRE status information.", "OK", { duration: 3000 })
                    })
                  }, () => {
                    this.snackbar.open("Failed to submit", "OK", { duration: 3000 })
                  })


                } else {
                  this.disableSubmitLandRecords = false
                }
              })
          })

        } else {
          this.snackbar.open(resp.message ? resp.message : "Something went wrong", "OK", { duration: 3000 })
        }
      },(err)=>{
        this.loading = false;
        this.snackbar.open("Failed to submit Land record","OK",{duration:5000})
      });
    }
  }


  submitLandRecords() {
    const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
      width: 'auto', height: 'auto',
      data: {
        content: constants.DYUWANNA_ADD_MORE_LANDS,
        button1Text: "Yes", button2Text: "No"
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      console.log(res)
      this.router
        .navigateByUrl("/laas/bre-status", {
          skipLocationChange: true,
        })
        .then(() => {
          this.router.navigate(["/laas/land-records-ka"]);
        }).then(() => {
          if (res == "close") {

            let id = sessionStorage.getItem('wl-applicant-id');
            let status = 'No'
            let value = { status, id }
            this.applicant.clickSubmit(value).subscribe(res => {
              console.log('final result', res)
              if (res.success == true) {
                this.hideSubmitButton = true;
                this.creditCheckRequired = res.creditCheckRequired;
              } else {
                this.hideSubmitButton = false;
              }

              this.showDelete = false;
              this.disableSubmitLandRecords = true
              this.applicant.getLandDetails().subscribe(resp => {
                console.log(resp)
                if (resp && resp.files) {
                  let mappingData = resp.files;
                  let breArray = [];
                  for (let i = 0; i < mappingData.length; i++) {
                    if (mappingData[i] && mappingData[i].land_bre_status == ("success" || "Success")) {

                    } else if (mappingData[i] && mappingData[i].land_bre_status == ("failure" || "Failure")) {
                      console.log(mappingData[i])
                      this.isLandBreFailure = true
                    }
                  }
                  // this.isLandBreFailure = false
                  if (!this.isLandBreFailure && this.creditCheckRequired) {
                    this.applicant.getCreditData(this.stateCode, this.repeatGetCreditScoreAPICount).subscribe(resp => {
                      console.log(resp)
                      if (resp && resp.success &&
                        (resp.message == "Report Generated Successfully" ||
                          resp.message == "Credit Report fetched successfully")) {
                        if (resp && resp.npaStatusFlag == false) {
                          this.fruitsService.getBreStatus().subscribe(result => {
                            console.log(result);
                            // result = "Failure"
                            if (result == "Failure" || result == "failure") {
                              this.snackbar.open(resp.bre_failure_reason ? resp.bre_failure_reason : "Failed in BRE", "OK", { duration: 5000 })
                            } else if (result == "Success" || result == "success") {
                              this.applicant.getOverAllStatus().subscribe(resp => {
                                console.log(resp)
                                if (resp && resp.message == "success") {
                                  if (resp && resp.data && resp.data.satSureData == true && resp.data.isSmsSent == true) {
                                    this.disableSubmitLandRecords = true
                                  } else if (resp && resp.data && resp.data.isSmsSent == false) {
                                    let data = {
                                      appId: sessionStorage.getItem('wl-applicant-id'),
                                    }
                                    // this.applicant.callSatsure(data).subscribe(resp => {
                                    //   console.log(resp)
                                    //   if (resp && resp.success) {
                                    this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                                      console.log(resp)
                                      if (resp && resp.success) {
                                        this.disableSubmitLandRecords = true
                                      }
                                    })
                                    //   }
                                    // })
                                  } else if (resp && resp.data && resp.data.satSureData == true && resp.data.isSmsSent == false) {
                                    // this.disableSubmitLandRecords = false
                                    this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                                      console.log(resp)
                                      if (resp && resp.success) {
                                        this.disableSubmitLandRecords = true
                                      }
                                    })
                                  } else if (resp && resp.data && resp.data.satSureData == false && resp.data.isSmsSent == true && resp.data.consent_feedback_status == "yes") {
                                    let data = {
                                      appId: sessionStorage.getItem('wl-applicant-id'),
                                    }
                                    this.applicant.callSatsure(data).subscribe(resp => {
                                      console.log(resp)
                                      if (resp && resp.success) {
                                        this.disableSubmitLandRecords = true
                                      }
                                    })
                                  } else {
                                    this.disableSubmitLandRecords = true
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.snackbar.open('NPA status found', 'OK', { duration: 3000 })
                        }
                      } else {
                        this.repeatGetCreditScoreAPICount =
                          this.repeatGetCreditScoreAPICount + 1;
                        this.applicant.getCreditData(this.stateCode, this.repeatGetCreditScoreAPICount).subscribe(resp => {
                          console.log(resp)
                          if (resp && resp.success &&
                            (resp.message == "Report Generated Successfully" ||
                              resp.message == "Credit Report fetched successfully")) {
                            if (resp && resp.npaStatusFlag == false) {
                              this.fruitsService.getBreStatus().subscribe(result => {
                                console.log(result);
                                // result = "Failure"
                                if (result == "Failure" || result == "failure") {
                                  this.snackbar.open(resp.bre_failure_reason ? resp.bre_failure_reason : "Failed in BRE", "OK", { duration: 5000 })
                                } else if (result == "Success" || result == "success") {
                                  this.applicant.getOverAllStatus().subscribe(resp => {
                                    console.log(resp)
                                    if (resp && resp.message == "success") {
                                      if (resp && resp.data && resp.data.satSureData == true && resp.data.isSmsSent == true) {
                                        this.disableSubmitLandRecords = true
                                      } else if (resp && resp.data && resp.data.isSmsSent == false) {
                                        let data = {
                                          appId: sessionStorage.getItem('wl-applicant-id'),
                                        }
                                        // this.applicant.callSatsure(data).subscribe(resp => {
                                        //   console.log(resp)
                                        //   if (resp && resp.success) {
                                        this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                                          console.log(resp)
                                          if (resp && resp.success) {
                                            this.disableSubmitLandRecords = true
                                          }
                                        })
                                        //   }
                                        // })
                                      } else if (resp && resp.data && resp.data.satSureData == true && resp.data.isSmsSent == false) {
                                        // this.disableSubmitLandRecords = false
                                        this.applicant.sendSmsManual(sessionStorage.getItem('wl-applicant-id')).subscribe(resp => {
                                          console.log(resp)
                                          if (resp && resp.success) {
                                            this.disableSubmitLandRecords = true
                                          }
                                        })
                                      } else if (resp && resp.data && resp.data.satSureData == false && resp.data.isSmsSent == true && resp.data.consent_feedback_status == "yes") {
                                        let data = {
                                          appId: sessionStorage.getItem('wl-applicant-id'),
                                        }
                                        this.applicant.callSatsure(data).subscribe(resp => {
                                          console.log(resp)
                                          if (resp && resp.success) {
                                            this.disableSubmitLandRecords = true
                                          }
                                        })
                                      } else {
                                        this.disableSubmitLandRecords = true
                                      }
                                    }
                                  })
                                }
                              })
                            } else {
                              this.snackbar.open('NPA status found', 'OK', { duration: 3000 })
                            }
                          }
                        })
                      }
                    })
                  } else {
                    this.snackbar.open("Land BRE failure found.", "OK", { duration: 3000 })
                  }

                } else {
                  this.snackbar.open("Failed to fetch Land records BRE status information.", "OK", { duration: 3000 })
                }
              }, () => {
                this.snackbar.open("Failed to fetch Land records BRE status information.", "OK", { duration: 3000 })
              })
            }, () => {
              this.snackbar.open("Failed to submit", "OK", { duration: 3000 })
            })

          } else {
            this.disableSubmitLandRecords = false
          }
        })

    })
  }

  sanitization(name) {
    const payload = { applicantId: this.getApplicantID(), name1: name };
    return this.api.sanpost("users/matchName", payload).pipe(map((res) => {
      console.log("Match Name: ", res);
      return res;
    }));
  }

  getApplicantID() {
    return sessionStorage.getItem("wl-applicant-id");
  }

  showDialog(
    width: any,
    height: any,
    content1: string,
    content2: string,
    buttonText: string
  ) {
    let dialogRef = this.dialog.open(OpenDialogYesOrNo, {
      width: width,
      height: height,
      data: {
        content: content1,
        content1: content2,
        button1Text: buttonText,
      },
    });

    return dialogRef;
  }
}
